import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { KkmsPageComponent } from './kkms-page/kkms-page.component';
import { KkmDetailsComponent } from './kkm-details/kkm-details.component';
import { ReportComponent } from './report/report.component';
import { NewKkmComponent } from './new-kkm/new-kkm.component';
import { VpnComponent } from './vpn/vpn.component';
import { RetailPlaceDetailsComponent } from './retail-place-details/retail-place-details.component';
import { RetailPlaceSettingsComponent } from './retail-place-settings/retail-place-settings.component';
import { SharedModule } from '../../shared/shared.module';
import { KkmsRoutingModule } from './kkms-routing.module';
import { RetailPlaceComponent } from './retail-place/retail-place.component';
import { VpnFormComponent } from './vpn/vpn-form/vpn-form.component';
import { VpnSignComponent } from './vpn/vpn-sign/vpn-sign.component';
import { KkmComponent } from './kkm/kkm.component';
import { OperationsComponent } from './report/operations/operations.component';
import { KkmRegFormComponent } from './new-kkm/kkm-reg-form/kkm-reg-form.component';
import { KkmSignComponent } from './new-kkm/kkm-sign/kkm-sign.component';
import { KkmSignPdfComponent } from './kkm-operations/kkm-sign-pdf/kkm-sign-pdf.component';
import { KkmReRegFormComponent } from './new-kkm/kkm-rereg-form/kkm-rereg-form.component';
import { KkmDeRegFormComponent } from './new-kkm/kkm-dereg-form/kkm-dereg-form.component';
import { DatepickerModule } from '../../shared/datepicker/datepicker.module';
import { TransactionComponent } from './transaction/transaction.component';
import { ReportTransactionComponent } from './report-transaction/report-transaction.component';
import { TransactionReportTotalsComponent } from './transaction/transaction-report-totals/transaction-report-totals.component';
import { TransactionReportSumComponent } from './transaction/transaction-report-sum/transaction-report-sum.component';
import { NewRetailPlaceComponent } from './new-retail-place/new-retail-place.component';
import { DeregisterComponent } from './deregister/deregister.component';
import { RemoveRetailPlaceComponent } from './remove-retail-place/remove-retail-place.component';
import { TokenComponent } from './token/token.component';
import { TransactionsFilterFormComponent } from './kkm-details/transactions-filter-form/transactions-filter-form.component';
import { KkmDetailHeaderInfoComponent } from './kkm-details/kkm-detail-header-info/kkm-detail-header-info.component';
import { ReRegisterKkmComponent } from './kkm-operations/re-register-kkm/re-register-kkm.component';
import { DeregisterKkmComponent } from './kkm-operations/deregister-kkm/deregister-kkm.component';
import { KkmsPageFilterComponent } from './kkms-page-filter/kkms-page-filter.component';
import { ModalModule } from '../../core/modal/modal.module';
import { TariffsModule } from '../tariffs/tariffs.module';
import { SignSelectedTariffPageComponent } from './sign-selected-tariff-page/sign-selected-tariff-page.component';
import { SubscriptionsModule } from '../tariffs/subscriptions/subscriptions.module';
import { DeregisterKkmSignComponent } from './kkm-operations/deregister-kkm/deregister-kkm-sign/deregister-kkm-sign.component';
import { EmptyListComponent } from '../../shared/empty-list/empty-list.component';
import { ReportIbericaComponent } from '../analytics/report-page/report-iberica/report-iberica.component';
import { KzCurrencyDecimalPipe } from '../../shared/pipes/kz-currency-decimal.pipe';
import { KkmRegisterMethodsComponent } from './kkms-page/kkm-register-methods/kkm-register-methods.component';
import { ChangeOfdModalComponent } from './change-ofd-modal/change-ofd-modal.component';
import { ChangeOfdAgreementComponent } from './change-ofd-agreement/change-ofd-agreement.component';
import { CancelDisconnectionOfdModalComponent } from './cancel-disconnection-ofd-modal/cancel-disconnection-ofd-modal.component';
import { CancelDisconnectionOfdAgreementComponent } from './cancel-disconnection-ofd-agreement/cancel-disconnection-ofd-agreement.component';
import { ReportTypeFiltersComponent } from './kkm-details/transactions-filter-form/report-type-filters/report-type-filters.component';

@NgModule({
  imports: [
    KkmsRoutingModule,
    SharedModule,
    FormsModule,
    DatepickerModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    ReactiveFormsModule,
    ModalModule,
    TariffsModule,
    SubscriptionsModule,
    EmptyListComponent,
    KkmsPageFilterComponent,
    RetailPlaceComponent,
    KkmComponent,
    ReportIbericaComponent,
    KzCurrencyDecimalPipe,
    KkmRegisterMethodsComponent,
    ReportTypeFiltersComponent,
  ],
  exports: [
    ReportComponent,
  ],
  declarations: [
    KkmsPageComponent,
    KkmDetailsComponent,
    ReportComponent,
    NewKkmComponent,
    OperationsComponent,
    VpnComponent,
    RetailPlaceDetailsComponent,
    RetailPlaceSettingsComponent,
    VpnFormComponent,
    VpnSignComponent,
    KkmRegFormComponent,
    KkmSignComponent,
    KkmSignPdfComponent,
    KkmReRegFormComponent,
    KkmDeRegFormComponent,
    TransactionComponent,
    ReportTransactionComponent,
    TransactionReportTotalsComponent,
    TransactionReportSumComponent,
    NewRetailPlaceComponent,
    DeregisterComponent,
    TokenComponent,
    RemoveRetailPlaceComponent,
    TransactionsFilterFormComponent,
    KkmDetailHeaderInfoComponent,
    DeregisterKkmComponent,
    DeregisterKkmSignComponent,
    ReRegisterKkmComponent,
    SignSelectedTariffPageComponent,
    ChangeOfdModalComponent,
    ChangeOfdAgreementComponent,
    CancelDisconnectionOfdModalComponent,
    CancelDisconnectionOfdAgreementComponent,
  ],
  providers: [
    KzCurrencyDecimalPipe,
  ],
})
export class KkmsModule {
}
